import React, { ChangeEvent } from 'react';
import { FormControl, MenuItem, Select, SelectProps } from '@material-ui/core';
import { Colors } from 'library';

interface DropdownProps extends SelectProps {
    fields: { key: string | number; value: string }[];
    value: string | number;
    onChange: (event: ChangeEvent<{ name?: string; value: any }>) => void;
    fullWidth?: boolean;
}

export default function OutlinedDropdown({
    fields,
    value,
    onChange,
    style,
    fullWidth = false,
    ...props
}: DropdownProps) {
    let form_ctrl_style = {};
    if (fullWidth) {
        form_ctrl_style = { width: '100%' };
    }

    return (
        <FormControl variant="outlined" style={form_ctrl_style}>
            <Select
                autoWidth
                value={value}
                onChange={onChange}
                style={{
                    padding: 0,
                    borderRadius: 18,
                    borderWidth: 0.1,
                    height: 40,
                    width: '100%',
                    backgroundColor: Colors.white,
                    fontFamily: 'Work Sans',
                    color: Colors.darkNavy,
                    ...style,
                }}
                {...props}
            >
                {fields.map((field) => (
                    <MenuItem
                        key={field.key}
                        value={field.key}
                        style={{ width: '100%', fontFamily: 'Work Sans', color: Colors.darkNavy }}
                    >
                        {field.value}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
